import { OFFSEC_SERVICES } from '../OffSec/ServiceRequests/offsecServicesConfig';

// Display labels for the stored role_name values. The stored values stay
// "Reviewer"/"Tester" (backend role gates match on them); only the UI text changes.
export const ROLE_LABELS = { Reviewer: 'OffSec Practice Head', Tester: 'Tester' };
export const roleLabel = (role) => ROLE_LABELS[role] || role;

// Manual lifecycle steps, keyed by the current phase. `owner` mirrors the
// backend's PHASE_OWNER (engagement/services.py) - earlier phases are set
// automatically by authorization / schedule saves.
export const NEXT_PHASE = {
  scheduled: { key: 'testing_in_progress', owner: 'Tester', label: 'Start Testing' },
  testing_in_progress: { key: 'initial_report', owner: 'Tester', label: 'Complete Testing' },
  initial_report: { key: 'remediation_in_progress', owner: 'Reviewer', label: 'Move to Remediation' },
  remediation_in_progress: { key: 'revalidation', owner: 'Reviewer', label: 'Move to Revalidation' },
  revalidation: { key: 'final_report', owner: 'Reviewer', label: 'Move to Final Report' },
  final_report: { key: 'closed', owner: 'Reviewer', label: 'Close Engagement' },
};

// Same order as the backend's LIFECYCLE_PHASES.
export const PHASE_ORDER = [
  'request_submitted', 'scope_confirmed', 'authorization_approved', 'scheduled',
  'testing_in_progress', 'initial_report', 'remediation_in_progress',
  'revalidation', 'final_report', 'closed',
];

export const phaseLabel = (key) => {
  const text = (key || '').replace(/_/g, ' ');
  return text.charAt(0).toUpperCase() + text.slice(1);
};

// Findings can only be recorded once testing has started (backend:
// findings/services.py::_require_testing_started).
export const hasTestingStarted = (phaseKey) =>
  PHASE_ORDER.indexOf(phaseKey) >= PHASE_ORDER.indexOf('testing_in_progress');

const SERVICE_LABELS = Object.fromEntries(OFFSEC_SERVICES.map((s) => [s.key, s.label]));

export const serviceLabel = (key) => SERVICE_LABELS[key] || key;

// Report upload rules - mirrors api/domains/offsec/reports/services.py
// (REPORT_MIN_PHASE / REVIEWER_ONLY_REPORT_TYPES), which enforces them.
// Each report opens at its engagement phase and stays open after (revisions).
export const REPORT_UPLOAD_RULES = [
  { type: 'Initial Technical Report', minPhase: 'initial_report', after: 'testing is complete' },
  { type: 'Executive Summary Report', minPhase: 'initial_report', after: 'testing is complete', reviewerOnly: true },
  { type: 'Remediation Status Report', minPhase: 'remediation_in_progress', after: 'Remediation In Progress' },
  { type: 'Revalidation Report', minPhase: 'revalidation', after: 'Revalidation' },
  { type: 'Final Closure Report', minPhase: 'final_report', after: 'Final Report' },
  { type: 'Board Report', minPhase: 'final_report', after: 'Final Report', reviewerOnly: true },
];
export const REPORT_TYPES = REPORT_UPLOAD_RULES.map((r) => r.type);

// Why `role` can't upload `reportType` on an engagement in `phaseKey` ('' = allowed).
export const reportUploadBlocker = (reportType, phaseKey, role) => {
  const rule = REPORT_UPLOAD_RULES.find((r) => r.type === reportType);
  if (!rule) return 'Unknown report type.';
  if (rule.reviewerOnly && role !== 'Reviewer') return 'OffSec Practice Head only';
  if (PHASE_ORDER.indexOf(phaseKey) < PHASE_ORDER.indexOf(rule.minPhase)) return `Available after ${rule.after}`;
  return '';
};
